// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/commercial-hero-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/cta-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commercial-page {
  padding-top: 0px;
  min-height: calc(100vh - 80px);
}

/* Hero Section */
.commercial-hero {
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover;
  height: 60vh;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding: 2rem;
}

.hero-content {
  max-width: 800px;
}

.hero-content h1 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  color: #D4AF37;
}

.hero-content p {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* Section Styles */
.section-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
}

section h2 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2.5rem;
  color: #526015;
  text-align: center;
  margin-bottom: 3rem;
}

/* Why Choose Us Section */
.why-choose-us {
  background-color: #f9f9f9;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.feature {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature:hover {
  transform: translateY(-5px);
}

.feature h3 {
  color: #D4AF37;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

/* Services Section */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.service-card {
  background: white;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.service-card h3 {
  color: #526015;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.service-card ul {
  list-style: none;
  padding: 0;
  margin-top: 1rem;
}

.service-card li {
  padding: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

.service-card li:before {
  content: "•";
  color: #D4AF37;
  position: absolute;
  left: 0;
}

/* Benefits Section */
.benefits-section {
  background-color: #f9f9f9;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.benefit-card {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.benefit-card h3 {
  color: #D4AF37;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

/* CTA Section */
.cta-section {
  background: linear-gradient(rgba(82, 96, 21, 0.9), rgba(82, 96, 21, 0.9)),
              url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover;
  color: white;
  text-align: center;
}

.cta-section h2 {
  color: white;
}

.cta-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 2rem;
}

.primary-button, .secondary-button {
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Josefin Sans', sans-serif;
}

.primary-button {
  background: #D4AF37;
  color: white;
  border: none;
}

.secondary-button {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.primary-button:hover {
  background: #c4a030;
  transform: translateY(-2px);
}

.secondary-button:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .commercial-hero {
    height: 50vh;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }

  .section-content {
    padding: 3rem 1.5rem;
  }

  section h2 {
    font-size: 2rem;
  }

  .cta-buttons {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 2rem;
  }

  .hero-content p {
    font-size: 1.1rem;
  }

  .section-content {
    padding: 2rem 1rem;
  }

  section h2 {
    font-size: 1.75rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/CommercialPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE;kEACgE;EAChE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE;kEACoD;EACpD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".commercial-page {\n  padding-top: 0px;\n  min-height: calc(100vh - 80px);\n}\n\n/* Hero Section */\n.commercial-hero {\n  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),\n              url('../assets/commercial-hero-bg.jpg') center/cover;\n  height: 60vh;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: white;\n  padding: 2rem;\n}\n\n.hero-content {\n  max-width: 800px;\n}\n\n.hero-content h1 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  color: #D4AF37;\n}\n\n.hero-content p {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n/* Section Styles */\n.section-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 4rem 2rem;\n}\n\nsection h2 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2.5rem;\n  color: #526015;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n/* Why Choose Us Section */\n.why-choose-us {\n  background-color: #f9f9f9;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.feature {\n  text-align: center;\n  padding: 2rem;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.feature:hover {\n  transform: translateY(-5px);\n}\n\n.feature h3 {\n  color: #D4AF37;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Services Section */\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.service-card {\n  background: white;\n  border-radius: 10px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.service-card h3 {\n  color: #526015;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.service-card ul {\n  list-style: none;\n  padding: 0;\n  margin-top: 1rem;\n}\n\n.service-card li {\n  padding: 0.5rem 0;\n  padding-left: 1.5rem;\n  position: relative;\n}\n\n.service-card li:before {\n  content: \"•\";\n  color: #D4AF37;\n  position: absolute;\n  left: 0;\n}\n\n/* Benefits Section */\n.benefits-section {\n  background-color: #f9f9f9;\n}\n\n.benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.benefit-card {\n  text-align: center;\n  padding: 2rem;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.benefit-card h3 {\n  color: #D4AF37;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n/* CTA Section */\n.cta-section {\n  background: linear-gradient(rgba(82, 96, 21, 0.9), rgba(82, 96, 21, 0.9)),\n              url('../assets/cta-bg.jpg') center/cover;\n  color: white;\n  text-align: center;\n}\n\n.cta-section h2 {\n  color: white;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.primary-button, .secondary-button {\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.primary-button {\n  background: #D4AF37;\n  color: white;\n  border: none;\n}\n\n.secondary-button {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n}\n\n.primary-button:hover {\n  background: #c4a030;\n  transform: translateY(-2px);\n}\n\n.secondary-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .commercial-hero {\n    height: 50vh;\n  }\n\n  .hero-content h1 {\n    font-size: 2.5rem;\n  }\n\n  .section-content {\n    padding: 3rem 1.5rem;\n  }\n\n  section h2 {\n    font-size: 2rem;\n  }\n\n  .cta-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-content h1 {\n    font-size: 2rem;\n  }\n\n  .hero-content p {\n    font-size: 1.1rem;\n  }\n\n  .section-content {\n    padding: 2rem 1rem;\n  }\n\n  section h2 {\n    font-size: 1.75rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
